document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rte table').forEach(function (table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
});
